import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import BreakFastScanner from "./Events/BreakFastScanner";
import CodeDesign from "./Events/CodeDesign";
import ReviewListOfSpotRegistration from "./Events/ReviewListOfSpotRegistration";
import SpotRegistration from "./Events/SpotRegistration";
import HeaderForSporRegistration from "./common/HeaderForSporRegistration";
import Navbar from "./common/Navbar";
import ExpressEntry from "./Events/ExpressEntry";
import BadgePrintAssign from "./Events/BadgePrintAssign";
import BadgeAssigned from "./Events/BadgeAssigned";
import ExpressEntryPrint from "./Events/ExpressEntryPrint";
import BadgePrintCard from "./Events/BadgePrintCard";
import Login from "./Events/Login";
import ProtectedRoute from "./ProtectedRoute";
import BadgeReAssigned from "./Events/BadgeReAssigned";
import SeparateActivity from "./Events/SeparateActivity";
import AdminActivityList from "./Events/AdminActivityList";
import ThankYou from "./Events/ThankyouMessage";
import CheckInActivity from "./Events/CheckInActivity";
import Dashboard from "./Events/dashboard/dashboard";
import TotaldelegateActivityView from "./Events/dashboard/TotaldelegateActivityView";
import SingleDelefateActivityView from "./Events/dashboard/SingleDelefateActivityView";

function AppWrapper() {
  const location = useLocation();
  const hideHeaderAndNavbar = location.pathname === "/badge-print-card";

  return (
    <>
      {!hideHeaderAndNavbar && <Navbar />}
      {!hideHeaderAndNavbar && <HeaderForSporRegistration />}

      <Routes>
        <Route path="/admin/login" element={<Login />} />
        <Route
          path="/express-entry/:id/:assignedId"
          element={
            <ProtectedRoute allowedRoles={[3, 5, 7, 8]}>
              <ExpressEntry />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry-print/:id"
          element={<ExpressEntryPrint />}
        />
        <Route path="/" element={<BreakFastScanner />} />
        <Route path="/code-design" element={<CodeDesign />} />
        <Route path="/spot-registration" element={<SpotRegistration />} />
        <Route
          path="/badge-print-card"
          element={
            <ProtectedRoute allowedRoles={[3, 5, 7, 8]}>
              <BadgePrintCard />{" "}
            </ProtectedRoute>
          }
        />
        <Route
          path="/review-list-of-spot-registration"
          element={
            <ProtectedRoute allowedRoles={[3, 5, 7, 8]}>
              <ReviewListOfSpotRegistration />
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry/badge-print"
          element={
            <ProtectedRoute allowedRoles={[3, 5, 7, 8]}>
              <BadgePrintAssign />
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry/badge-assigned"
          element={
            <ProtectedRoute allowedRoles={[3, 5, 7, 8]}>
              <BadgeAssigned />
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry/check-in"
          element={
            <ProtectedRoute allowedRoles={[3, 5, 7, 8, 9]}>
              <CheckInActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry/badge-reassigned"
          element={
            <ProtectedRoute allowedRoles={[7, 8]}>
              <BadgeReAssigned />
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry/separate-activity/:id"
          element={
            <ProtectedRoute allowedRoles={[8]}>
              <SeparateActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/express-entry/admin-badge-list"
          element={
            <ProtectedRoute allowedRoles={[8]}>
              <AdminActivityList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/activitiest"
          element={
            <ProtectedRoute allowedRoles={[10]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/total-delegates"
          element={
            <ProtectedRoute allowedRoles={[10]}>
              <TotaldelegateActivityView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/single-activities"
          element={
            <ProtectedRoute allowedRoles={[10]}>
              <SingleDelefateActivityView />
            </ProtectedRoute>
          }
        />
        <Route path="/thankyou" element={<ThankYou />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
